<template>
  <v-container
    class="auth-view bg-blue-darken-3"
    fluid
  >
    <v-row
      justify="center"
      align="center"
      class="fill-height"
    >
      <v-col
        cols="12"
        align="center"
        class="mb-16"
      >
        <div
          class="mb-4 d-flex"
          style="max-width: 766px; align-items: center; justify-content: center;"
        >
          <v-img
            src="@/assets/icon-white.png"
            contain
            max-width="100"
            max-height="75"
            class="d-inline-block"
          />
          <div class="d-inline-block text-white text-left">
            <div
              class="text-button"
              style="margin-bottom: -10px;"
            >Webwalker</div>
            <div class="text-overline">Affiliate</div>
          </div>
        </div>
        <v-card
          color="white"
          elevation="3"
          class="pa-3 mb-4 text-left"
          style="max-width: 766px; border-top: 4px solid #2196F3 !important; border-top-left-radius: 0; border-top-right-radius: 0;"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                lg="7"
                md="6"
                sm="12"
              >
                <v-card-title class="text-h5">
                  <slot name="title">{{ title }}</slot>
                </v-card-title>

                <slot />
              </v-col>
              <v-col
                cols="1"
                lg="1"
                md="1"
                class="d-none d-md-block text-center"
              >
                <v-divider
                  vertical
                  style="border-color: rgba(0, 0, 0, 0.75);"
                />
              </v-col>
              <v-col
                cols="12"
                lg="4"
                md="5"
                sm="12"
              >
                <v-divider
                  class="d-md-none"
                  style="border-color: rgba(0, 0, 0, 0.75);"
                />

                <br />

                <slot name="side" />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <div
          class="mb-16"
          style="position: relative;"
        >
          <base-error-alerts />
        </div>
      </v-col>
    </v-row>
    <slot name="other" />
  </v-container>
</template>

<script>
export default {
  name: 'BaseAuthViewContainer',

  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.auth-view {
  min-height: 100vh !important;
  min-height: calc(100vh - 48px) !important;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center bottom;
  box-shadow: inset 0 0 0 2000px rgba(21, 101, 192, 0.9);
}

.fill-height {
  min-height: inherit;
}
</style>
